module.exports = __webpack_public_path__ + "static/media/zajednica.3b29d920.svg";